const lightGallery = require('./vendor/lightgallery.min.js');
const lgThumbnail = require('./vendor/lg-thumbnail.min.js');
const lgVideo = require('./vendor/lg-video.min.js');

jQuery(function($) {
    const galleryInstances = new Map();

    function setupLightBoxElements() {
        const lightgalleryElements = $('.js-lightgallery');
        const lightboxElements = $('.js-lightbox-video');

        Array.from(lightgalleryElements).forEach((lightgallery, index) => {
            lightgallery.id = `gallery-${index}`;
            
            const lgInstance = lightGallery(lightgallery, {
                thumbnail: true,
                plugins: [lgThumbnail],
                selector: '.light-gallery-item',
                trapFocus: true,
                closable: true,
                closeOnTap: true,
                enableSwipe: false,
                resetScrollPosition: true,
                download: false,
                counter: false,
                width: '90%',
                getCaptionFromTitleOrAlt: false,
                licenseKey: '7193FD74-868442F8-AFC59789-16D26BC0',
                mobileSettings: {
                    controls: true,
                    showCloseIcon: true,
                    download: false,
                }
            });

            galleryInstances.set(lightgallery, { instance: lgInstance, lastFocused: null });
            handleLightboxEvents(lightgallery);
        });

        // Embedded media / videos
        Array.from(lightboxElements).forEach((lightbox, index) => {
            lightbox.id = `video-${index}`;

            const lgInstance = lightGallery(lightbox, {
                plugins: [lgVideo],
                download: false,
                counter: false,
                width: '90%',
                trapFocus: true,
                closable: true,
                closeOnTap: true,
                enableSwipe: false,
                resetScrollPosition: true,
                controls: false,
                youTubePlayerParams: {
                    modestbranding: 1
                },
                getCaptionFromTitleOrAlt: false,
                licenseKey: '7193FD74-868442F8-AFC59789-16D26BC0',
                mobileSettings: {
                    showCloseIcon: true,
                    download: false,
                },
            });

            galleryInstances.set(lightbox, { instance: lgInstance, lastFocused: null });
            handleLightboxEvents(lightbox);
        });
    }

    function handleLightboxEvents(lightbox, isVideo) {
        const galleryData = galleryInstances.get(lightbox);

        lightbox.addEventListener('lgBeforeOpen', () => {
            const coverLink = lightbox.querySelector('.c-col-embedded-media__cover-link') || lightbox.querySelector('.c-col-gallery__link');
            galleryData.lastFocused = coverLink;

            if (isVideo) {
                window.addEventListener('keydown', galleryData.handleKeydown);
            }
        });

        lightbox.addEventListener('lgBeforeClose', () => {
            if (galleryData.lastFocused) {
                galleryData.lastFocused.focus();
                galleryData.lastFocused = null;
            }

            if (isVideo) {
                window.removeEventListener('keydown', galleryData.handleKeydown);
            }
        });

        galleryData.handleKeydown = (e) => {
            if (e.key === 'Tab' && e.target.classList.contains('lg-close')) {
                e.preventDefault();
                const wrapper = e.target.closest('.lg-video-wrapper');
                if (wrapper) {
                    const video = wrapper.querySelector('.lg-video-object');
                    if (video) {
                        video.focus();
                    }
                }
            }
        };
    }

    function handleGalleryButtonsEvents() {
        const galleryButtons = document.querySelectorAll(".c-col-gallery__cta");
        
        galleryButtons.forEach(el => {
            const parentGallery = el.closest('.js-lightgallery');
            const firstItem = parentGallery && parentGallery.querySelector('.light-gallery-item');
            
            if (firstItem) {
                el.addEventListener('click', () => {
                    firstItem.dispatchEvent(new CustomEvent('click', { bubbles: true, cancelable: true }));
                });
            }
        });
    }

    setupLightBoxElements();
    handleGalleryButtonsEvents();
});


// WEBPACK FOOTER //
// ./src/js/gallery.js